// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const hitmontop: PokeData = {
  "id": 237,
  "name": "hitmontop",
  "height": 14,
  "weight": 480,
  "base_experience": 159,
  "types": [
    PokeType.FIGHTING
  ],
  "api_moves": [
    "rolling-kick",
    "tackle",
    "counter",
    "dig",
    "agility",
    "quick-attack",
    "focus-energy",
    "triple-kick",
    "detect",
    "pursuit",
    "rapid-spin",
    "fake-out",
    "helping-hand",
    "revenge",
    "endeavor",
    "gyro-ball",
    "feint",
    "close-combat",
    "sucker-punch",
    "wide-guard",
    "quick-guard"
  ],
  "moves": [
    "rolling-kick",
    "tackle",
    "quick-attack",
    "pursuit",
    "close-combat",
    "superpower",
    "bulk-up",
    "coaching",
    "double-kick",
    "drain-punch",
    "vacuum-wave",
    "karate-chop",
    "meteor-assault"
  ],
  "evolution_chain": {
    "id": 47,
    "item": null,
    "species": [
      {
        "name": "tyrogue",
        "order": 115,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "hitmonlee",
        "order": 116,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 236,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": 1,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "hitmonchan",
        "order": 117,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 236,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": -1,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "hitmontop",
        "order": 118,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 236,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": 0,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 126,
    "speed": 116,
    "ability_power": 158
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
